import {
  faSpinner,
  faCheckCircle,
  faClose,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import MessageModal from "./MessageModal";
import { faTriangleExclamation } from "@fortawesome/free-solid-svg-icons/faTriangleExclamation";

const EditCTScanReportRegister = ({
  report_report_main_title,
  report_field_ct_scan_report_technique,
  report_field_ct_scan_report_findings,
  report_field_ct_scan_report_impression,
  report_field_ct_scan_report_status,
  report_report_nid,
  toggleModalEditReport,
}) => {
  const [isMessageModalVisible, setIsMessageModalVisible] = useState(false);
  const [isMessageModalVisibleError, setIsMessageModalVisibleError] =
    useState(false);
  const [isMessageErrorState, setIsMessageErrorState] = useState("");

  const [loading, setLoading] = useState(false);

  const [ctscanReportTitle, setctscanReportTitle] = useState(
    report_report_main_title,
  );

  const [ctscanReportTechnique, setctscanReportTechnique] = useState(
    report_field_ct_scan_report_technique,
  );

  const [ctscanFindings, setctscanFindings] = useState(
    report_field_ct_scan_report_findings,
  );

  const [ctscanImpression, setctscanImpression] = useState(
    report_field_ct_scan_report_impression,
  );

  const [ctscanreportStatus, setctscanreportStatus] = useState(
    report_field_ct_scan_report_status,
  );

  console.log("REPORT REPORT NODE ID:::", report_report_nid);

  const toggleModalClose = () => setIsMessageModalVisible(false);
  const toggleModalCloseError = () => setIsMessageModalVisibleError(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      // Refresh token before submitting
      const res = await fetch(
        `${process.env.REACT_APP_BASE_URL}/session/token`,
        {
          credentials: "include",
        },
      );
      const freshToken = await res.text();

      const reportEditPayload = {
        type: [{ target_id: "ct_scan_report" }],
        title: [{ value: ctscanReportTitle }],
        field_ct_scan_report_technique: [{ value: ctscanReportTechnique }],
        field_ct_scan_report_findings: [{ value: ctscanFindings }],
        field_ct_scan_report_impression: [{ value: ctscanImpression }],
        field_ct_scan_report_status: [{ value: ctscanreportStatus }],
      };

      const reportresponse = await fetch(
        `${process.env.REACT_APP_BASE_URL}/node/${report_report_nid}?_format=json`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            "X-CSRF-Token": freshToken,
          },
          credentials: "include",
          body: JSON.stringify(reportEditPayload),
        },
      );

      if (!reportresponse.ok) {
        const error = await reportresponse.json();
        setIsMessageErrorState(`Failed to edit the report: ${error.message}`);
        setIsMessageModalVisibleError(true); // ✅ Show error modal
        console.log(`Failed to edit the report:", ${error.message}`);
        setLoading(false);
        return;
      }
      setctscanReportTitle("");
      setctscanReportTechnique("");
      setctscanFindings("");
      setctscanImpression("");
      setctscanreportStatus("");
      setLoading(false);
      setIsMessageModalVisible(true);
      setTimeout(() => {
        setIsMessageModalVisible(false);
        toggleModalEditReport(); // close the edit modal form
      }, 2000);
    } catch (error) {
      console.log("Network Error:", error);
      setIsMessageErrorState("Network error occurred. Please try again.");
      setIsMessageModalVisibleError(true); // ✅ Show error modal for network errors too
      setLoading(false);
    }
  };

  return (
    <div className="edit-ctscan-report-register">
      <form onSubmit={handleSubmit} className="patient-form">
        <div className="form-group">
          <label htmlFor="field_ct-scan-report-title">Report title</label>
          <input
            type="text"
            placeholder="Add Report Title"
            value={ctscanReportTitle}
            onChange={(e) => setctscanReportTitle(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="field_ct-scan-report-technique">Technique</label>
          <textarea
            type="textarea"
            placeholder="Add Technique"
            value={ctscanReportTechnique}
            onChange={(e) => setctscanReportTechnique(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="field_ct-scan-report-findings">Findings</label>
          <textarea
            type="textarea"
            placeholder="Add Findings"
            value={ctscanFindings}
            onChange={(e) => setctscanFindings(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="field_ct-scan-report-impression">Impression</label>
          <textarea
            type="textarea"
            placeholder="Add Findings"
            value={ctscanImpression}
            onChange={(e) => setctscanImpression(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="field_ct-scan-report-status">Status</label>
          <select
            value={ctscanreportStatus}
            onChange={(e) => setctscanreportStatus(e.target.value)}
            required
          >
            <option value="">Select Status</option>
            <option value="pending" selected={true}>
              Pending
            </option>
            {/* <option value="assigned">Assigned</option> */}
            <option value="completed">Completed</option>
          </select>
        </div>
        <div className="submitGroup">
          <button type="submit" disabled={loading}>
            {loading ? (
              <FontAwesomeIcon
                icon={faSpinner}
                spin={true}
                strokeWidth={20}
                fontSize={22}
              />
            ) : (
              "Submit"
            )}
          </button>
        </div>
      </form>

      {isMessageModalVisible && (
        <MessageModal
          leftIcon={faCheckCircle}
          color="green"
          fontSize={20}
          message="CT Scan Request edited Successfully!"
          onClose={toggleModalClose}
          rightIcon={faClose}
        />
      )}

      {isMessageModalVisibleError && (
        <MessageModal
          leftIcon={faTriangleExclamation}
          color="red"
          fontSize={20}
          message={isMessageErrorState}
          onClose={toggleModalCloseError}
          rightIcon={faClose}
        />
      )}
    </div>
  );
};

export default EditCTScanReportRegister;
